import React, { Component } from 'react';
import { formatCurrency } from '@C/TableGrid';
import { BookOpenText } from 'lucide-react';

export class CashBook extends Component {
  constructor() {
    super();
    this.state = {
      tab: 1,
    };
  }

  render() {
    const summary = this.props.summary;
    return (
      <>
        <section className="widget dsr-table">
          <header>
            <BookOpenText color="#31af36" />
            <h3> Cash Book</h3>
          </header>
          <main>
            <table className="dsr" data-name="Cash Book">
              <tbody>
                <tr>
                  <td>Opening cash balance</td>
                  <td>{formatCurrency(summary.opening_balance || 0)}</td>
                </tr>
                <tr>
                  <td>Cash received from duties</td>
                  <td>
                    {formatCurrency(summary.cash_received_from_duties || 0)}
                  </td>
                </tr>
                <tr>
                  <td>Office Incomes</td>
                  <td>{formatCurrency(summary.all_incomes || 0)}</td>
                </tr>
                <tr>
                  <td>Office Expenses</td>
                  <td>{formatCurrency(summary.all_expenses || 0)}</td>
                </tr>
                <tr>
                  <td>Cash deposit to bank</td>
                  <td>{formatCurrency(summary.cash_deposit_to_bank || 0)}</td>
                </tr>
                <tr>
                  <td>Closing cash balance</td>
                  <td>{formatCurrency(summary.closing_cash_balance || 0)}</td>
                </tr>
              </tbody>
            </table>
          </main>
        </section>
      </>
    );
  }
}
